import { useStableCallback } from "@bezoned/shared/hooks/use-stable-callback.js";
import { Combobox, Field, Option } from "@fluentui/react-components";
import { useQuery } from "@tanstack/react-query";

import { teamsGet } from "../../../../services/api.service.js";

interface SelectTeamProps {
  label: string;
  // TODO: Fix this with form composition later on
  // Lint exception: FormApi has complex generic signature, using any for flexibility
  field: any;
}

export const SelectTeam = ({ field, label = "Office" }: SelectTeamProps) => {
  const {
    data: teamsResponse,
    isLoading,
    error,
  } = useQuery({
    queryFn: () => teamsGet({}),
    queryKey: ["teamsGet"],
  });

  const comboboxPlaceholder = () => {
    if (isLoading) {
      return "Loading offices...";
    }

    if (!teamsResponse || teamsResponse.teams.length === 0) {
      return "No offices available.";
    }

    return "Select an office";
  };

  // Get validation state from TanStack Form
  const fieldState = field.state;
  const hasError = fieldState.meta.errors.length > 0;
  const validationMessage = fieldState.meta.errors[0];
  const teams = teamsResponse?.teams ?? [];
  const handleOptionSelect50 = useStableCallback((_, data) => {
    field.handleChange(data.optionValue ?? null);
  });

  return (
    <Field
      label={label}
      required={true}
      validationMessage={validationMessage || error}
      validationState={hasError || error ? "error" : "none"}
    >
      <Combobox
        autoComplete="off"
        className="w-full"
        disabled={teams.length === 0 || isLoading || error !== null}
        onOptionSelect={handleOptionSelect50}
        placeholder={comboboxPlaceholder()}
        value={teams.find((t) => t.id === field.state.value)?.name || ""}
      >
        {teams.map((team) => (
          <Option key={team.id} value={team.id}>
            {team.name}
          </Option>
        ))}
      </Combobox>
    </Field>
  );
};
